import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Contact from "@/views/contact/Contact";
import {AppConfig} from "@/config";
import Test from "@/views/test/Test";
import MainHeaderMenuPhone from "@/views/header/MainHeaderMenuPhone";
import {isShowMenuPhone} from "@/views/data/CommonData";
import Footer from "@/views/foot/Footer.vue";
import Header from "@/views/header/Header.vue";
import QrCodeDialog from "@/views/contact/QrCodeDialog.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(AppConfig).isPro)
      ? (_openBlock(), _createBlock(Header, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (_unref(AppConfig).isPro)
      ? (_openBlock(), _createBlock(Footer, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(AppConfig).isPro)
      ? (_openBlock(), _createBlock(_unref(Contact), { key: 2 }))
      : _createCommentVNode("", true),
    (!_unref(AppConfig).isPro)
      ? (_openBlock(), _createBlock(_unref(Test), { key: 3 }))
      : _createCommentVNode("", true),
    (_unref(isShowMenuPhone))
      ? (_openBlock(), _createBlock(_unref(MainHeaderMenuPhone), { key: 4 }))
      : _createCommentVNode("", true),
    _createVNode(QrCodeDialog)
  ], 64))
}
}

})